import config from '../../config/generated.json'

export default function isOutletsShowOutletBanner() {
  return config.ui.isOutletsShowOutletBanner
}
